import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Statistic, Table, DatePicker, message } from 'antd';
import { DollarOutlined, UserOutlined, TransactionOutlined } from '@ant-design/icons';
import withMosadIsolation from '../../utils/withMosadIsolation';
import styles from './Dashboard.module.css';
import dayjs from 'dayjs';
import { useTranslation } from '../../i18n';

const { RangePicker } = DatePicker;

const Dashboard = ({ api }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [metrics, setMetrics] = useState({
    totalTransactions: 0,
    totalAmount: 0,
    activeCustomers: 0,
    pendingTransactions: 0,
  });
  const [recentTransactions, setRecentTransactions] = useState([]);

// DEFAULT DATE RANGE: last 3 months → today (dayjs version)
  const [dateRange, setDateRange] = useState([
    dayjs().subtract(2, 'month'),
    dayjs(),
  ]);

  // const currentMosadToken = localStorage.getItem(config.APP_NAME + '_mosadToken');
  
  // if (!currentMosadToken) {
  //   navigate('/mosads');
  // }

  useEffect(() => {
    fetchDashboardData();
  }, [api, dateRange]);

   const fetchDashboardData = async () => {
    try {
      setLoading(true);

      const startDate = dateRange?.[0]?.format('YYYY-MM-DD');
      const endDate = dateRange?.[1]?.format('YYYY-MM-DD');

      console.log("Sending:", { startDate, endDate });

      const [metricsResponse, transactionsResponse] = await Promise.all([
        api.get('/dashboard/metrics', {
          params: { startDate, endDate },
        }),
        api.get('/dashboard/recent-transactions', {
          params: { limit: 5 },
        }),
      ]);

      setMetrics(metricsResponse.data || metricsResponse);
      setRecentTransactions(transactionsResponse.data || transactionsResponse);

    } catch (error) {
      console.log(error);
      message.error(t('notifications.frontend.common.failedToFetchDashboardData'));
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: t('ui.dashboard.ascNum'),
      dataIndex: 'ascNum',
      key: 'ascNum',
      align: 'center',
    },
    {
      title: t('ui.dashboard.createDate'),
      dataIndex: 'createDate',
      key: 'createDate',
      render: (createDate) => new Date(createDate).toLocaleDateString(),
      align: 'center',
    },
    {
      title: t('ui.dashboard.customer'),
      dataIndex: 'customerName',
      key: 'customerName',
      align: 'center',
    },
    {
      title: t('ui.dashboard.date'),
      dataIndex: 'date',
      key: 'date',
      render: (date) => new Date(date).toLocaleDateString(),
      align: 'center',
    },
    {
      title: t('ui.dashboard.amount'),
      dataIndex: 'amount',
      key: 'amount',
      render: (amount) => `${amount.toLocaleString()} ₪`,
      align: 'center',
    },
    {
      title: t('ui.dashboard.exportedToRivhit'),
      dataIndex: 'status',
      key: 'status',
      render: (status) => (
        // <span className={`${styles.status} ${styles[status]}`}>
          // {status}
          <span style={{ textAlign: 'center' }}>{status ? t('ui.dashboard.yes') : t('ui.dashboard.no')}</span>
        // {/* </span> */}
      ),
      align: 'center',
    },
  ];

  return (
    <div className={styles.container}>
      {/* <div className={styles.header}> */}
      {/* <h2>{t('ui.dashboard.title')}</h2> */}

      <div style={{ display: "flex", flexDirection: "row", gap: 10, alignItems: "center", flexWrap: "wrap" }}>
        <label style={{color: "rgba(0, 0, 0, 0.85)" }}>
        {/* {t("ui.transactions.createDate")} */}
        {t('ui.billing.selectDate')}
        </label>
        <RangePicker
        direction="rtl"
          value={dateRange}
          onChange={setDateRange}
        />
      </div>

      <div style={{ marginTop: 10 }}>
      <Row gutter={[16, 16]}>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title={t('ui.dashboard.totalTransactions')}
              value={metrics.totalTransactions}
              prefix={<TransactionOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title={t('ui.dashboard.totalAmount')}
              value={metrics.totalAmount}
              prefix={<DollarOutlined />}
              valueStyle={{ color: '#3f8600' }}
              suffix="₪"
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title={t('ui.dashboard.activeCustomers')}
              value={metrics.activeCustomers}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>
        <Col xs={24} sm={12} lg={6}>
          <Card>
            <Statistic
              title={t('ui.dashboard.pendingTransactions')}
              value={metrics.pendingTransactions}
              prefix={<TransactionOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
      </Row>
      </div>

      <div style={{ marginTop: 20 }}>
      <Card
        title={t('ui.dashboard.recentTransactions')}
        // className={styles.recentTransactions}
      >
        <Table
          columns={columns}
          dataSource={recentTransactions}
          loading={loading}
          rowKey="id"
          pagination={false}
          size="small"
        />
      </Card>
      </div>
    </div>
  );
};

export default withMosadIsolation(Dashboard); 